// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__VWH9L","insightsList":"newBusinessInsightsMenu_insightsList__2YVPk","active":"newBusinessInsightsMenu_active__3Ee5E"};